import React, { useState, useRef, useEffect } from 'react';
import styles from '../styles/ProtectedEmail.module.css';

/**
 * Componente para mostrar direcciones de correo electrónico protegidas contra rastreadores
 * Utiliza técnicas avanzadas de ofuscación para evitar que los rastreadores detecten el correo
 */
const ProtectedEmail = ({ email, linkText }) => {
  const [showEmail, setShowEmail] = useState(false);
  const emailRef = useRef(null);
  const timerRef = useRef(null);
  
  // Dividir y codificar el correo electrónico para evitar rastreadores
  const parts = email.split('@');
  const domain = parts[1] ? parts[1].split('.') : [];
  
  // Codificar cada parte usando String.fromCharCode para evitar que aparezca en el código fuente
  const encodeText = (text) => {
    return Array.from(text)
      .map(char => char.charCodeAt(0))
      .reduce((acc, code) => acc + String.fromCharCode(code), '');
  };
  
  const username = encodeText(parts[0] || '');
  const domainName = encodeText(domain[0] || '');
  const tld = encodeText(domain[1] || '');
  
  // Construir el correo electrónico solo cuando sea necesario
  const getEmailAddress = () => {
    return `${username}@${domainName}.${tld}`;
  };
  
  const handleClick = (e) => {
    if (!showEmail) {
      e.preventDefault();
      setShowEmail(true);
      
      // Establecer un temporizador para ocultar el correo después de 20 segundos
      timerRef.current = setTimeout(() => {
        setShowEmail(false);
      }, 20000);
    }
  };
  
  // Manejar clics fuera del enlace de correo
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showEmail && emailRef.current && !emailRef.current.contains(event.target)) {
        setShowEmail(false);
        if (timerRef.current) {
          clearTimeout(timerRef.current);
        }
      }
    };
    
    document.addEventListener('mousedown', handleClickOutside);
    
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, [showEmail]);
  
  return (
    <a
      ref={emailRef}
      {...(showEmail ? { href: `mailto:${getEmailAddress()}` } : {})}
      onClick={handleClick}
      className={showEmail ? styles.emailRevealed : styles.emailProtected}
      role="button"
      tabIndex={0}
      data-email-protected="true"
      aria-label="Correo electrónico protegido"
    >
      {showEmail ? (
        <>
          <span className={styles.emailPart}>{username}</span>
          <span className={styles.emailSymbol}>@</span>
          <span className={styles.emailPart}>{domainName}</span>
          <span className={styles.emailDot}>.</span>
          <span className={styles.emailPart}>{tld}</span>
        </>
      ) : (
        linkText || 'Contacto'
      )}
    </a>
  );
};

export default ProtectedEmail;